import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import Header from './header'
import { getCurrentPartner } from 'selectors/settings'

export class HeaderContainer extends Component {

  render() {
    return (
      <Header partner={this.props.partner} />
    )
  }

}

HeaderContainer.propTypes = {
  partner: PropTypes.object,
}

const mapStateToProps = state => ({
  partner: getCurrentPartner(state),
})

export default connect(mapStateToProps)(HeaderContainer)



/** WEBPACK FOOTER **
 ** ./src/components/header/header-container.js
 **/